module.exports = __webpack_public_path__ + "img/banner2.62cfed42.jpg";